export default "__VITE_ASSET__682hfoIt__"